<app-form-editors
    [item]="selectedEditor"
    (onValidate)="validate($event)"
    (onCancel)="cancel($event)">
</app-form-editors>